import { render, staticRenderFns } from "./HandbookSearchResult.vue?vue&type=template&id=3080cf64&"
import script from "./HandbookSearchResult.vue?vue&type=script&lang=js&"
export * from "./HandbookSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports